var memberSession = {
    
    MemberFullName: '',
    MemberGuid: '',
    MemberName: '',
    MemberSurname: '',
    UserName: '',
    MemberEmail: '',
    MemberCellphone: '',
    HoldingCompanyID: 0,
    TransactionCount: 0,
    MasterAccount: '',
    MemberTypeID: 0,
    MemberType: '',
    SelectedBasketGuid: ''
}

export default memberSession;
